import { gsap, ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
  let timelines = [];

  const initAnimations = () => {
    const counterBlocks = gsap.utils.toArray(".js-counter-block");

    counterBlocks.forEach((block) => {
      const years = block.querySelector(".js-years");
      const counterContent = block.querySelectorAll(".js-counter-content");
      const counters = block.querySelectorAll(".js-counter");
      const steps = counterContent.length - 1;
      const headerHeight = document.querySelector(".header").offsetHeight;
      const stopTriggerMobileFixed = (block.querySelector('.js-counter-wrapper').offsetHeight);

      ScrollTrigger.matchMedia({
        "(max-width: 1023px)": () => {
          gsap.timeline({
            defaults: {
              ease: "none",
            },
            scrollTrigger: {
              trigger: years,
              start: `top top+=${headerHeight}`,
              end: `${stopTriggerMobileFixed}px`,
              pin: true,
              pinSpacing: false,
              scrub: false,
            },
          });

          for (let i = 0; i <= steps; i++) {
            const masterTimeline = gsap.timeline({
              scrollTrigger: {
                trigger: counterContent[i],
                start: 'top 70%',
                end: `+=100%`,
                pin: false,
                pinSpacing: false,
                markers: false,
                toggleActions: "play none none reverse",
              },
            })

            counters.forEach((counter, step) => {
              const numbers = counter.querySelectorAll('.number');
              if (numbers.length > 1) {
                numbers.forEach((num, index) => {
                  if(num.dataset.trans == i) {
                    masterTimeline.to(
                      counter, {
                        y: `-${index * 100}%`,
                        duration: 1,
                        delay: 0.2 * step,
                      },
                      `step-${i}`
                    );
      
                    timelines.push(masterTimeline);
                  }
                })
              }
            });
          }
        },
        "(min-width: 1024px)": () => {
          gsap.timeline({
            scrollTrigger: {
              trigger: years,
              start: `center center`,
              endTrigger: counterContent[steps],
              end: `bottom top`,
              pin: true,
              pinSpacing: false,
              scrub: false,
            },
          });

          for (let i = 0; i <= steps; i++) {
            const isFirstStep = i === 0;
            const isLastStep = i === steps;

            const masterTimeline = gsap.timeline({
              scrollTrigger: {
                trigger: counterContent[i],
                start: `center center`,
                endTrigger: !isLastStep ? counterContent[i + 1] : counterContent[steps],
                end: !isLastStep ? `center center` : `bottom top`,
                pin: !isLastStep ? counterContent[i] : counterContent[steps],
                pinSpacing: !isLastStep ? false : true,
                toggleActions: "play none none reverse",
                onLeave: () => {
                    if (!isLastStep) {
                        counterContent[i].classList.add('leave')
                    }
                },

                onEnterBack: () => {
                    counterContent[i].classList.remove('leave')
                },
              },
            })

            if (!isFirstStep) {
              masterTimeline.fromTo(
                counterContent[i], {
                  opacity: 0,
                  y: "100vh",
                }, {
                  opacity: 1,
                  y: 0,
                  duration: 1,
                },
                `step-${i}`
              )
            }
            counters.forEach((counter, step) => {
              const numbers = counter.querySelectorAll('.number');
              if (numbers.length > 1) {
                numbers.forEach((num, index) => {
                  if(num.dataset.trans == i) {
                    masterTimeline.to(
                      counter, {
                        y: `-${index * 100}%`,
                        duration: 1,
                        delay: 0.2 * step,
                      },
                      `step-${i}`
                    );
      
                    timelines.push(masterTimeline);
                  }
                })
              }
            });
          }
        },
      })
    });

    ScrollTrigger.sort();
  };

  initAnimations();
});
